import { LinearProgress } from '@mui/material';

export function CustomLoadingOverlay() {
  return <LinearProgress />;
}
